import type { DefaultResponseBody, WidgetSection } from "@gerama/types";
import type { ApiClient } from "../client";

export function createCoreWidgetsApi(client: ApiClient) {
  return {
    /** Home feed — `GET /widgets/feed` (Page Builder, resolved & ready to render). */
    feed: (platform: "web" = "web", signal?: AbortSignal) =>
      client
        .request<DefaultResponseBody<WidgetSection[]>>("/widgets/feed", {
          query: { platform },
          signal,
        })
        .then((res) => res.data ?? []),
  };
}
